var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-slider-thumb-wrapper",class:{ 'is-dragging': false, 'has-indicator': _vm.indicator },style:(_vm.wrapperStyle)},[_c('div',_vm._b({staticClass:"b-slider-thumb",attrs:{"tabindex":_vm.disabled ? false : 0}},'div',_vm.$attrs,false),[(_vm.indicator)?_c('span',[_vm._v(_vm._s(_vm.formattedValue))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }